<template>
  <div
    v-if="number>0"
    @click="$emit('click')"
  >
    <div
      v-tooltip="getTooltip"
      class="vtbubble d-flex align-items-center justify-content-center ml-1"
      :class="{incidence: type, info: info, indicator: indicator}"
    >
      <span>{{ number }}</span>
    </div>
  </div>
</template>

<script>

export default {
    name: 'VtBubble',
    props: {
        number: Number,
        type: Boolean,
        tooltip: String,
        info: Boolean,
        indicator: Boolean
    },
    data() {
        return {
            file: ''
        }
    },
    computed: {
        getTooltip() {
            if (this.tooltip) {
                return `${this.number} ${this.tooltip}`
            }
            return ''
        }
    }
}

</script>

<style  lang="scss">

.vtbubble{
    background: vt-color(success);
    border-radius: 24px;
    padding: 0 4.5px;
    color: #FFF !important;
    cursor: pointer;
}

.vtbubble span{
    font-size: font-size(tiny) !important;
    color: #FFF !important;
}

.incidence{
    background: vt-color(red-medium);
}

.vtbubble.info{
    background: vt-color(info);
}

.vtbubble.indicator{
    background: vt-color(primary);
}

</style>
